import NavSlot from "@/components/navigation/links";
import { Outlet, useLocation } from "react-router-dom";
import MyTeamTasks from "./my-team";
import MeTasks from "./me";
import AssignedByMeTasks from "./assigned-by-me";

export const TaskStatus = [
  {
    label: "Me",
    value: "me",
    path: "/tasks/me",
    element: MeTasks,
  },
  {
    label: "My Team",
    value: "my-team",
    path: "/tasks/my-team",
    element: MyTeamTasks,
  },
  {
    label: "Assigned by Me",
    value: "assigned-by-me",
    path: "/tasks/assigned-by-me",
    element: AssignedByMeTasks,
  },
];

const TasksLayout = () => {
  const { pathname } = useLocation();
  const isCreating =
    pathname.endsWith("/tasks/+") || pathname.endsWith("/tasks/%2B");

  return (
    <div className="flex-1 overflow-auto relative ">
      {!isCreating && (
        <div className="sticky w-full bg-white z-1">
          <NavSlot navItems={TaskStatus} />
        </div>
      )}
      <Outlet />
    </div>
  );
};

export default TasksLayout;
